import React, { createContext, useContext, useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { environment } from '../config/environment';
import { getAccessToken } from '../auth/tokenStorage';

type ChatContextType = {
  socket: Socket | null;
  onlineUsers: number;
  setOnlineUsers: React.Dispatch<React.SetStateAction<number>>;
};

const ChatContext = createContext<ChatContextType | undefined>(undefined);

interface ChatProviderProps {
  children: React.ReactNode;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [onlineUsers, setOnlineUsers] = useState<number>(0);

  useEffect(() => {
    const token = getAccessToken();
    const newSocket = io(environment.coreServerUrl, {
      autoConnect: true,
      auth: token ? { token } : undefined,
      transports: ['websocket', 'polling'],
    });
    setSocket(newSocket);

    newSocket.on('onlineUsers', (count: number) => {
      setOnlineUsers(count);
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return (
    <ChatContext.Provider value={{ socket, onlineUsers, setOnlineUsers }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = (): ChatContextType => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};
